<script>
export default {
  name: 'TreeMenu',
  props: {
    treeData: { type: Array, required: true },
    treeProps: {
      type: Object,
      default: () => ({
        label: 'label',
        children: 'children',
      }),
    },
  },
  data() {
    return {
      formattedTreeData: this.makeTreeData(this.treeData),
    }
  },
  methods: {
    // treeDataにid, isLeafを付与する
    makeTreeData(tree) {
      let id = 1
      const walk = (nodes) => {
        return nodes.map((node) => {
          const hasChildren = 'children' in node && Array.isArray(node.children) && node.children.length > 0
          const newNode = { ...node, id: id++, isLeaf: !hasChildren }
          if (hasChildren) {
            newNode.children = walk(node.children)
          }
          return newNode
        })
      }
      return walk(tree)
    },
    // 指定idのノードと親情報を取得する
    findNodeWithParents(tree, targetId, parents = []) {
      for (const node of tree) {
        if (node.id === targetId) {
          return { node, parents }
        }
        if (node.children) {
          const result = this.findNodeWithParents(node.children, targetId, [...parents, node])
          if (result) return result
        }
      }
      return null
    },
    handleNodeClick(data) {
      const { node, parents } = this.findNodeWithParents(this.formattedTreeData, data.id)
      this.$emit('node-click', { node, parents })
    },
  },
}
</script>

<template>
  <el-tree
    class="treeMenuContainer"
    :data="formattedTreeData"
    :props="treeProps"
    highlight-current
    @node-click="handleNodeClick"
    node-key="id"
  />
</template>

<style scoped>
.treeMenuContainer {
  overflow-y: auto;
}
</style>
